import {
	BankAccount,
	FollowDto,
	HostNotificationMode,
	PaginatedEntity,
	RegisterHostProfileV2Dto,
	RegisterHostProfileV2ResponseDto,
	restRepository,
	User,
	UserEntity,
} from "@onair/repositories";
import { useAuthStore } from "@onair/store/auth";

export interface IGetFollowings {
	followingIds: string[];
}

const upsertUserBankAccount = async (payload: BankAccount): Promise<User> => {
	const res = await restRepository.api.userControllerUpdateBankAccount(payload);
	useAuthStore.setState((old) => ({ ...old, ...res?.data }));
	return res.data;
};

const upsertMultipleUserBankAccount = async (
	payload: BankAccount[],
): Promise<User> => {
	const res =
		await restRepository.api.userControllerUpsertBankAccounts(payload);
	useAuthStore.setState((old) => ({ ...old, ...res?.data }));
	return res.data;
};

const checkUserPaymentMethodInUse = async (bankAccountId: string) => {
	const res = await restRepository.api.userControllerCheckPaymentMethodInUse({ id: bankAccountId });
	return res.data;
};

const getTopHosts = async ({ queryKey }) => {
	const [, , limit] = queryKey;
	const data = await restRepository.api.userGetTopHosts({
		limit: limit,
	});

	return data.data;
};

const getUsersBySearch = async (
	searchText: string,
): Promise<PaginatedEntity & { items?: UserEntity[] }> => {
	const res = await restRepository.api.getUsers({
		take: 20,
		skip: 0,
		filter: JSON.stringify({
			where: {
				AND: [
					{
						OR: [
							{
								username: {
									contains: searchText,
									mode: "insensitive",
								},
							},
							{
								fullName: {
									contains: searchText,
									mode: "insensitive",
								},
							},
							{
								email: {
									contains: searchText,
									mode: "insensitive",
								},
							},
						],
					},
				],
			},
		}),
	});

	return res.data;
};

const hostRegisterV2 = async (
	request: RegisterHostProfileV2Dto,
): Promise<RegisterHostProfileV2ResponseDto> => {
	try {
		const { data } = await restRepository.api.hostRegisterV2(request);
		return data as RegisterHostProfileV2ResponseDto;
	} catch (error) {
		return {
			success: false,
		};
	}
};

const getFollowings = async (params: IGetFollowings) => {
	const { data } = await restRepository.api.getFollowings({
		followingIds: params.followingIds.length
			? params.followingIds.join(",")
			: undefined,
	});
	return data;
};

const doFollow = async (params: FollowDto) => {
	const { data } = await restRepository.api.follow(params);
	return data;
};

const doUnfollow = async (params: FollowDto) => {
	const { data } = await restRepository.api.unfollow(params);
	return data;
};

const updateHostNotificationMode = async (mode: HostNotificationMode) => {
	const { data } = await restRepository.api.userUpdateHostNotificationMode({
		mode,
	});
	return data;
};

export {
	checkUserPaymentMethodInUse, doFollow,
	doUnfollow,
	getFollowings,
	getTopHosts,
	getUsersBySearch,
	hostRegisterV2,
	upsertMultipleUserBankAccount,
	upsertUserBankAccount,
	updateHostNotificationMode,
};

